import type { CommitmentVersionSensitive } from '@festina/life-general-types/life'
import { CommitmentsVersionsSensitiveService_commitmentVersionsSensitiveServiceGetEntity } from '@festina/life-general-types/life/hooks/CommitmentsVersionsSensitiveService_commitmentVersionsSensitiveServiceGetEntity'

export const useFetchCommitmentVersionSensitive =
  CommitmentsVersionsSensitiveService_commitmentVersionsSensitiveServiceGetEntity.useSuspenseQuery<CommitmentVersionSensitive | null>
